import React from 'react';
import { motion } from 'framer-motion';

function Hero() {
  return (
    <section className="hero section-wrap" id="top">
      <motion.div
        className="hero-copy"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="eyebrow"><span className="eyebrow-dot" /> A voice practice for admissions teams</span>
        <h1>Practice the AI conversation before the family walks in.</h1>
        <p className="hero-lede">
          A short voice role-play where you guide a worried parent through using AI on college applications, then get feedback on how you did.
        </p>
        <a className="button button-primary" href="#session">
          Start the practice session <span aria-hidden="true">→</span>
        </a>
        <div className="hero-note">
          <span className="note-icon" aria-hidden="true">◷</span>
          About 10 minutes · No installation needed
        </div>
      </motion.div>
      <motion.div
        className="hero-visual"
        data-image-slot="hero-image"
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, delay: 0.12 }}
      >
        <img
          src="https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=85"
          alt="A mother and her teenage son sitting together at home and talking"
        />
        <div className="image-caption">
          <span className="caption-dot" />
          A conversation worth practicing
        </div>
      </motion.div>
    </section>
  );
}

export default Hero;
